export enum UserActionType {
    HasLoggedIn,
    HasVisited,
    HasCreated,
    HasChanged,
    HasDeleted,
    HasCloned
}
